export const sortAnchorTagsByAnchorDocOrder = (orderedClassifierKeys, anchorTags) => {
    return [...orderedClassifierKeys, ...Array.from(anchorTags.keys())];
};
export const sortExtraTagsGroupedByCategory = (orderedClassifierKeys, extraTags) => {
    for (const classifier of extraTags.keys()) {
        const category = classifier.split(':')[0].trim();
        const keysMatchingClause = orderedClassifierKeys.filter(tagColumnKey => tagColumnKey.split(':')[0].trim() === category);
        if (keysMatchingClause.length) {
            const lastMatchingClassifier = keysMatchingClause[keysMatchingClause.length - 1];
            const lastClassifierMatchIndex = (orderedClassifierKeys.lastIndexOf(lastMatchingClassifier));
            orderedClassifierKeys.splice(lastClassifierMatchIndex + 1, 0, classifier);
        }
        else {
            orderedClassifierKeys.push(classifier);
        }
    }
    return orderedClassifierKeys;
};
